import React, { useEffect } from "react";

import FormControlLabel from "@material-ui/core/FormControlLabel";
// import InputLabel from "@material-ui/core/InputLabel";
import Grid from "@material-ui/core/Grid";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import Radio from "@material-ui/core/Radio";

import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles.js";

const EasySelect = props => {
  useEffect(() => {
    props.connectForm.setPropMounted(propName, true);
    return () => {
      props.connectForm.setPropMounted(propName, false);
    };
  }, []);

  const { classes } = props;
  const propName = props.propName;
  return (
    <Grid container align="center">
      <Grid item xs={10} md={6} lg={4}>
        {/* <InputLabel htmlFor={propName} className={classes.selectLabel}>
          {props.connectForm.getLabel(propName) + " "}
          {props.connectForm.isRequired(propName) ? (
            <span style={{ color: "red" }}>*</span>
          ) : (
            ""
          )}
        </InputLabel> */}
        {props.connectForm.getDropdownOptions(propName).map((element, key) => {
          var value, label;
          if (Array.isArray(element)) {
            value = element[0];
            label = element[1];
          } else {
            value = element;
            label = element;
          }
          return (
            <div
              key={propName + key}
              className={
                classes.checkboxAndRadio +
                " " +
                classes.checkboxAndRadioHorizontal
              }
            >
              <FormControlLabel
                control={
                  <Radio
                    checked={props.connectForm.getValue(propName) === value}
                    onChange={event =>
                      props.connectForm.change(event.target.value, propName)
                    }
                    value={value}
                    name={label}
                    aria-label={label}
                    icon={
                      <FiberManualRecord className={classes.radioUnchecked} />
                    }
                    checkedIcon={
                      <FiberManualRecord className={classes.radioChecked} />
                    }
                    classes={{
                      checked: classes.radio,
                      root: classes.radioRoot
                    }}
                  />
                }
                classes={{
                  label: classes.label
                }}
                label={label}
              />
            </div>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(EasySelect);

//
//
